import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { merge } from 'lodash-es';

export enum ManagementTypeKeys {
  none = 'none',
  core = 'core',
  system = 'system',
  dm = 'dm',
}
export type ManagementTypes = keyof typeof ManagementTypeKeys;

type TabKeys = {
  entity: { signUp: string; config: string };
  foo: { bar: string };
};

type TapKeyPayload = {
  [key in keyof TabKeys]?: Partial<TabKeys[key]>;
};

type States = {
  selectedManagement: ManagementTypes;
  tabKeys: TabKeys;
};

const initialState: States = {
  selectedManagement: 'none',
  tabKeys: {
    entity: {
      signUp: '',
      config: '',
    },
    foo: {
      bar: '',
    },
  },
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setTabKey: (state, action: PayloadAction<TapKeyPayload>) => {
      state.tabKeys = merge(state.tabKeys, action.payload);
    },
    setSelectedManagement: (state, action: PayloadAction<ManagementTypes>) => {
      state.selectedManagement = action.payload;
    },
  },
});

export const { setTabKey, setSelectedManagement } = globalSlice.actions;
